(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2176],{

/***/ 36783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin",
      function () {
        return __webpack_require__(93597);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Login; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61253);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48876);
/* harmony import */ var src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4048);
/* harmony import */ var src_components_Signup_Icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35034);
/* harmony import */ var src_components_Signup_SignupMethodButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72423);
/* harmony import */ var src_components_Splash_EnterToken__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39188);
/* harmony import */ var src_components_UI_Links__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47209);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










function Login() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__/* .AuthWrapper */ .cX, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__/* .AuthBody */ .CS, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__/* .AuthHeader */ .kP, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledText */ .qY, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_8__/* .StyledLink */ .Fg, {
                                    style: {
                                        color: "#cccccc"
                                    },
                                    children: "VIENNA HYPERTEXT"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                style: {
                                    color: "#cccccc"
                                },
                                children: " / "
                            }),
                            " Sign In"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FlexCenter, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Signup_SignupMethodButton__WEBPACK_IMPORTED_MODULE_6__/* .SignupMethodButton */ .ss, {
                                onClick: function() {
                                    return next_router__WEBPACK_IMPORTED_MODULE_3___default().push(src_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .AppRoutes.SigninEmail */ .$w.SigninEmail);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Signup_SignupMethodButton__WEBPACK_IMPORTED_MODULE_6__/* .IconWrapper */ .a1, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Signup_Icons__WEBPACK_IMPORTED_MODULE_5__/* .EmailIcon */ .L, {})
                                    }),
                                    "Sign in with Email"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Signup_SignupMethodButton__WEBPACK_IMPORTED_MODULE_6__/* .OrDivider */ .Xk, {
                                style: {
                                    marginTop: "0px",
                                    marginBottom: "5px"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Signup_SignupMethodButton__WEBPACK_IMPORTED_MODULE_6__/* .SignupMethodButton */ .ss, {
                                style: {
                                    marginTop: "10px"
                                },
                                onClick: function() {
                                    return next_router__WEBPACK_IMPORTED_MODULE_3___default().push(src_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .AppRoutes.SigninUrbit */ .$w.SigninUrbit);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Signup_SignupMethodButton__WEBPACK_IMPORTED_MODULE_6__/* .IconWrapper */ .a1, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Signup_Icons__WEBPACK_IMPORTED_MODULE_5__/* .UrbitIcon */ .I, {})
                                    }),
                                    "Sign in with Urbit"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__/* .EndOfFormText */ .Qx, {
                                children: [
                                    "Don't have an account? ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: src_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .AppRoutes.Waitlist */ .$w.Waitlist,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Splash_EnterToken__WEBPACK_IMPORTED_MODULE_7__/* .RedLink */ .G, {
                                            children: "Join waitlist"
                                        })
                                    }),
                                    " ",
                                    "or",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: src_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .AppRoutes.Register */ .$w.Register,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Splash_EnterToken__WEBPACK_IMPORTED_MODULE_7__/* .RedLink */ .G, {
                                            children: "sign up"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f1938091-0"
})(_templateObject());
var FlexCenter = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f1938091-1"
})(_templateObject1());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9188,9774,2888,179], function() { return __webpack_exec__(36783); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);